import constants from "./constants";
import createAction from "sagas/createAction";
import { createPromiseAction } from "@adobe/redux-saga-promise";

const actions = {
  AuthAdpro: (otp, token) => createAction(constants.AUTH_ADPRO, { otp, token }),
  SetAd: (ad) => createAction(constants.AD, { ad }),
  SetFacebookAd: (ad) => createAction(constants.FACEBOOK_AD, { ad }),
  SendAnalyticsPageView: (rmpBusinessId, adsAccountId, adsAccountName, page) =>
    createAction(constants.SEND_ANALYTICS_PAGE_VIEW, { rmpBusinessId, adsAccountId, adsAccountName, page }),
  SendAnalyticsLogin: (rmpBusinessId, adsAccountId, adsAccountName, rAdproCreateTime) =>
    createAction(constants.SEND_ANALYTICS_LOGIN, { rmpBusinessId, adsAccountId, adsAccountName, rAdproCreateTime }),
  currentDashboard: (dashboard) => createAction(constants.CURRENT_DASHBOARD, { dashboard }),
  loginToRdynamic: createPromiseAction(constants.LOGIN_TO_RDYNAMIC),
  getNexusUserInfo: createPromiseAction(constants.GET_NEXUS_USER_INFO),
  checkAppAvailable: createPromiseAction(constants.CHECK_APP_AVAILABLE),
};

export default actions;
